@if (loadingMentorContacts === true) {
  <div class="loadingSpinner" >
    <mat-spinner></mat-spinner>
  </div>
}
<div class="card-actions">
  <button [disabled]="enableAddContactLogButton === false" (click)="displayAddMentorContactForm()" type="button" color="primary" mat-button mat-raised-button>
    Add Contact Log
  </button>
</div>

@if (mentorContactsFound === true) {
  <table id="internData" mat-table [dataSource]="mentorContactsDataSource">
    <tbody>
      <ng-container matColumnDef="MentorName">
        <th mat-header-cell *matHeaderCellDef>Mentor</th>
        <td mat-cell *matCellDef="let element">
          {{element.mentorName}}
        </td>
      </ng-container>
      <ng-container matColumnDef="Note">
        <th mat-header-cell *matHeaderCellDef>Note</th>
        <td mat-cell *matCellDef="let element">
          {{element.note}}
        </td>
      </ng-container>
      <ng-container matColumnDef="CommunicationMethod">
        <th mat-header-cell *matHeaderCellDef>Communication Method</th>
        <td mat-cell *matCellDef="let element">
          {{element.communicationMethod}}
        </td>
      </ng-container>
      <ng-container matColumnDef="ContactedBy">
        <th mat-header-cell *matHeaderCellDef>Contacted By</th>
        <td mat-cell *matCellDef="let element">
          {{element.createUser}}
        </td>
      </ng-container>
      <ng-container matColumnDef="ContactDate">
        <th mat-header-cell *matHeaderCellDef>Contact Date</th>
        <td mat-cell *matCellDef="let element">
          {{element.contactDate | date : 'MM/dd/yyyy'}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="mentorContactsDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: mentorContactsDisplayedColumns;"></tr>
    </tbody>
  </table>
}
@if (mentorContactsFound === false && loadingMentorContacts === false) {
  <div>
    No mentor contact records found.
  </div>
}
